import { SectionPage } from './SectionPage';
import AccountPage from '@/pages/AccountPage';

export default function TeamSection() {
  return (
    <SectionPage sectionId="team">
      <AccountPage />
    </SectionPage>
  );
}
